<template>
  <div
    class="doc-viewer"
    :class="{ 'doc-viewer-compact': compact }"
  >
    <div class="doc-card">
      <div class="doc-hdr">
        <span class="doc-title">
          <span class="cite-badge">{{ citeNum(current, idx) }}</span>{{ current.title }}
        </span>
        <span class="doc-loc">{{ current.location || '' }}</span>
      </div>

      <div class="doc-stage">
        <!-- PDF: inline preview + open-in-new-tab overlay (lightbox stub) -->
        <div
          v-if="current.ext === '.pdf'"
          class="pdf-wrap w-full h-full"
        >
          <iframe
            :src="currentUrl + frag"
            :title="current.title"
            class="pdf-frame"
            loading="lazy"
          />
          <div
            class="pdf-click"
            title="Open in new tab"
            @click="openCurrent"
          >
            <span class="pdf-expand">⤢ Open</span>
          </div>
        </div>

        <!-- Non-PDF (DOCX/PPTX): icon + download fallback -->
        <div
          v-else
          class="doc-fallback"
        >
          <span class="doc-icon">{{ current.ext === '.pptx' ? '📊' : '📄' }}</span>
          <span class="doc-name">{{ current.title }}</span>
          <a
            :href="currentUrl"
            download
            class="dl-btn"
          >Download {{ extLabel }}</a>
        </div>
      </div>
    </div>

    <!-- Numbered dots carry the same [N] the answer text cites. Arrows only
         appear when there is more than one source to page through. -->
    <div class="doc-dots">
      <button
        v-if="docs.length > 1"
        class="doc-arrow"
        aria-label="Previous"
        :disabled="idx === 0"
        @click="idx--"
      >
        ‹
      </button>
      <button
        v-for="(doc, i) in docs"
        :key="i"
        class="doc-dot"
        :class="{ active: i === idx }"
        :aria-label="`Source ${citeNum(doc, i)}`"
        @click="idx = i"
      >
        {{ citeNum(doc, i) }}
      </button>
      <button
        v-if="docs.length > 1"
        class="doc-arrow"
        aria-label="Next"
        :disabled="idx === docs.length - 1"
        @click="idx++"
      >
        ›
      </button>
    </div>
  </div>
</template>

<script>
import { docUrl, pdfFrag } from '../api'

export default {
  props: {
    docs: {
      type: Array,
      required: true
    },
    // Fixed height (below the player row) vs. filling the panel when alone.
    compact: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      idx: 0
    }
  },

  computed: {
    current () {
      return this.docs[this.idx] || this.docs[0]
    },
    currentUrl () {
      return docUrl(this.current.file)
    },
    frag () {
      return pdfFrag(this.current.location)
    },
    extLabel () {
      return (this.current.ext || '').replace('.', '').toUpperCase()
    }
  },

  watch: {
    docs () {
      this.idx = 0
    }
  },

  methods: {
    // Each dot shows the source's citation number — the same [N] used in the
    // answer text — so a bracket in the reply maps onto the source shown here.
    citeNum (doc, i) {
      return doc && doc.cite != null ? doc.cite : i + 1
    },
    openCurrent () {
      window.open(this.currentUrl, '_blank', 'noopener')
    }
  }
}
</script>
